export const BRIDGE_METHODS = {
  FETCH_TOKEN: "FETCH_TOKEN",
  GENERATE_TOKEN: "GENERATE_TOKEN",
  FETCH_APP_INFO: "FETCH_APP_INFO",
  NAVIGATE_TO: "NAVIGATE_TO",
};

export const BRIDGE_NAME = "bg1";
